import React from 'react'
import PropTypes from 'prop-types'
import { Button, Header, Modal } from '@adc/ui-core'

const ConfirmationModal = props => {
  const onModalButtonClick = event => {
    const { onCreateAnother, onKeepEditing, onDone } = props
    const buttonId = event.currentTarget.id

    if (buttonId === 'create_another') {
      onCreateAnother()
    } else if (buttonId === 'keep_editing') {
      onKeepEditing()
    } else if (buttonId === 'done') {
      onDone()
    }
  }

  const { isEditMode, isModalOpen, recordId, onModalClose, entityName } = props
  return (
    isModalOpen && (
      <Modal
        closeOnDimmerClick={false}
        elmId='confirmation_modal'
        data-record-id={recordId}
        size='tiny'
        open={isModalOpen}
        onClose={onModalClose}
        closeIcon={false}
      >
        <Header
          icon={{ name: 'check', color: 'green' }}
          data-elm-id='confirmation_modal_entity_name'
          content={`${entityName} successfully ${
            isEditMode ? 'updated' : 'created'
          }!`}
        />
        <Modal.Content>
          <p>What would you like to do now?</p>
        </Modal.Content>
        <Modal.Actions>
          {!isEditMode && (
            <Button
              size='small'
              role='secondary'
              id='create_another'
              elmId='confirmation_create_another_button'
              onClick={onModalButtonClick}
            >
              Create Another
            </Button>
          )}
          <Button
            size='small'
            role='secondary'
            id='keep_editing'
            elmId='confirmation_keep_editing_button'
            onClick={onModalButtonClick}
          >
            Keep Editing
          </Button>
          <Button
            size='small'
            role='primary'
            id='done'
            elmId='confirmation_done_button'
            onClick={onModalButtonClick}
          >
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    )
  )
}

ConfirmationModal.propTypes = {
  entityName: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  recordId: PropTypes.number,
  onModalClose: PropTypes.func.isRequired,
  onCreateAnother: PropTypes.func.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
}

export default ConfirmationModal
